// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__13BX4"};